import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ReorderAction,
  ReorderButtonsComponent,
} from '../reorder-buttons/reorder-buttons.component';
import { TankSummaryComponent } from '../tank-transfer/tank-summary/tank-summary.component';
import { VesselTank } from '../vessel-tank.model';
import { TrashButtonComponent } from '../trash-button/trash-button.component';

@Component({
  selector: 're-tank-correction',
  templateUrl: './tank-correction.component.html',
  styleUrl: './tank-correction.component.css',
  imports: [
    ReactiveFormsModule,
    ReorderButtonsComponent,
    TankSummaryComponent,
    FormsModule,
    TrashButtonComponent,
  ],
})
export class TankCorrectionComponent implements OnInit {
  @Input({ required: true }) from!: VesselTank;
  @Input({ required: true }) action: any;
  @Output() reorder = new EventEmitter<{ id: number; action: ReorderAction }>();
  @Output() delete = new EventEmitter<any>();

  progress2 = 0;
  fromProgress = 0;
  correctionAmount = 0;

  get minAmount(): number {
    const quantity = this.from.content?.quantity ?? 0;
    return -quantity;
  }

  get maxAmount(): number {
    const quantity = this.from.content?.quantity ?? 0;
    return (this.from.capacity ?? 0) - quantity;
  }

  onModelChange() {
    this.action.tankOperations = [
      {
        tank: {
          ...this.from,
        },
        fuel: {
          fuelGrade: this.from.content?.fuelGrade,
          quantity: this.correctionAmount,
        },
      },
    ];
  }

  calculateProgress() {
    const capacity = this.from.capacity ?? 0;
    const quantity = this.from.content?.quantity ?? 0;

    this.progress2 =
      capacity > 0 ? (Math.abs(this.correctionAmount) / capacity) * 100 : 0;

    if (this.correctionAmount < 0) {
      this.fromProgress =
        capacity > 0
          ? ((quantity + this.correctionAmount) / capacity) * 100
          : 0;

      return;
    }

    this.fromProgress = capacity > 0 ? (quantity / capacity) * 100 : 0;
  }

  ngOnInit() {
    this.calculateProgress();
  }

  onResetTank() {
    this.correctionAmount = 0;
    this.calculateProgress();
    this.onModelChange();
  }

  onReorder(action: any) {
    this.reorder.emit({
      id: this.action.id,
      action: action,
    });
  }

  onDelete() {
    this.delete.emit(this.action);
  }

  onEmptyTank() {
    this.correctionAmount = -(this.from.content?.quantity ?? 0);
    this.calculateProgress();
    this.onModelChange();
  }

  onFillTank() {
    const quantity = this.from.content?.quantity ?? 0;
    this.correctionAmount = (this.from.capacity ?? 0) - quantity;
    this.calculateProgress();
    this.onModelChange();
  }

  onInputChange(): void {
    this.calculateProgress();
  }
}
